var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('video',{staticClass:"site-bg-video",attrs:{"autoPlay":"","muted":"","loop":"","src":require("../assets/bg-site.webm"),"type":"video/webm"},domProps:{"muted":true}}),_vm._v(" "),_c('new-home-block'),_vm._v(" "),_c('home-pendant'),_vm._v(" "),_c('home-center')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b50af752","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/build902/views/HOME.vue
// module id = null
// module chunks = 